import {useEffect, useState} from 'react';
import useDebounce from '@src/hooks/useDebounce';

const getParams = (element: HTMLElement | Window) => {
    const isWindow = element instanceof Window;

    return {
        width: isWindow ? element.innerWidth : element.scrollWidth,
        height: isWindow ? element.innerHeight : element.scrollHeight,
    };
};

export default function useResizeObserver(
    debounceDelay = 100,
    node: HTMLElement | Window = window,
) {
    const [params, setParams] = useState(getParams(node));
    const debouncedParams = useDebounce(params, debounceDelay);

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>;
        const resizeListener = () => {
            setParams(getParams(node));

            clearTimeout(timeout);
            timeout = setTimeout(() => setParams(getParams(node)), 300);
        };

        node.addEventListener('resize', resizeListener);

        return () => {
            clearTimeout(timeout);
            node.removeEventListener('resize', resizeListener);
        };
    }, [node]);

    return debouncedParams;
}
